import { DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useNavigation } from '@remix-run/react';
import { cn } from '@theprintbar/shared';
import { OutlineButton } from '../Button';

export interface ModalPanelProps {
	title?: string;
	onClose?: () => void;
	loading?: boolean;
	loadingTitle?: string;
	loadingText?: string;
	className?: string;
	useLoading?: boolean;
	children?: React.ReactNode;
}

export function ModalPanel({
	title,
	onClose,
	loading,
	loadingTitle,
	loadingText,
	className,
	useLoading = true,
	children,
}: ModalPanelProps) {
	const submitting = loading || useNavigation().state !== 'idle';

	return (
		<DialogPanel
			className={cn(
				'm-4 lg:m-8 py-4 lg:py-8 w-full lg:w-auto relative cursor-auto rounded-3xl bg-white border border-blue z-[999]',
				useLoading && 'min-w-96 min-h-96',
				className,
			)}
		>
			{useLoading && submitting ? (
				<div className="flex flex-col max-h-[65vh] overflow-y-auto items-center p-4 lg:p-8">
					<div className="text-center">
						<h4 className="text-blue mb-6">{loadingTitle || 'Loading...'}</h4>
						{loadingText && <p className="text-lg mt-4">{loadingText}</p>}
					</div>
					<img src="/images/loading.gif" alt="Cartoon person" className="w-72" />
				</div>
			) : (
				<>
					{title && (
						<DialogTitle className="flex justify-between items-center font-light text-lg lg:text-xl mb-2 lg:mb-4 px-4 lg:px-8">
							<span>{title}</span>
							{onClose && <OutlineButton className="p-1 lg:p-2" circle icon={XMarkIcon} onClick={() => onClose?.()} />}
						</DialogTitle>
					)}
					<div className="flex flex-col max-h-[65vh] overflow-y-auto px-4 lg:px-8">{children}</div>
				</>
			)}
		</DialogPanel>
	);
}
